import '../scss/utils/plugins/_light-gallery.scss'

import {LightGallery} from './components/LightGallery/LightGallery.js';
LightGallery()